module.exports = __webpack_public_path__ + "static/media/view.8b7f3634.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/view.svg
// module id = 86
// module chunks = 0